import { getDefaultAgentImageSrc } from "@jugl-web/domain-resources/chat-bot/utils/defaultAgentImages/defaultAgentImages";
import { FC, useMemo, useState } from "react";
import { ChatBotImagePicker } from "../../../../components/ChatBotImagePicker";
import { SelectAgentAvatarDialog } from "../SelectAgentAvatarDialog";

interface ChatBotAgentAvatarPickerProps {
  avatar: string | File | null;
  onAvatarChange: (avatar: string | File | null) => void;
}

export const ChatBotAgentAvatarPicker: FC<ChatBotAgentAvatarPickerProps> = ({
  avatar,
  onAvatarChange,
}) => {
  const [isSelectAgentDialogOpen, setIsSelectAgentDialogOpen] = useState(false);

  const adaptedImage = useMemo(() => {
    if (typeof avatar === "string" && avatar.startsWith("default")) {
      return getDefaultAgentImageSrc(avatar);
    }

    return avatar;
  }, [avatar]);

  return (
    <>
      <ChatBotImagePicker
        image={adaptedImage}
        onImageChange={() => setIsSelectAgentDialogOpen(true)}
        onImageRemove={() => onAvatarChange(null)}
      />
      <SelectAgentAvatarDialog
        isOpen={isSelectAgentDialogOpen}
        selectedAvatar={avatar}
        onAvatarChange={onAvatarChange}
        onClose={() => setIsSelectAgentDialogOpen(false)}
      />
    </>
  );
};
